import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/our-content.png'
import _imports_1 from '@/assets/images/shape-5.png'
import _imports_2 from '@/assets/images/shape-7.png'
import _imports_3 from '@/assets/images/shape-6.png'


const _hoisted_1 = { class: "our-content-area ptb-100 bg-gondola3 position-relative z-1" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = {
  class: "col-lg-6 col-xl-5",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "200"
}
const _hoisted_5 = { class: "our-content position-relative z-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-lg-6 col-xl-7" }, [
          _createElementVNode("div", { class: "our-content-img position-relative z-2 text-center text-lg-end" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "our-content",
              "data-aos": "fade-up",
              "data-aos-duration": "1000",
              "data-aos-delay": "100"
            }),
            _createElementVNode("img", {
              src: _imports_1,
              class: "shape shape-5 z-1",
              alt: "shape"
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createStaticVNode("<span class=\"top-title\">محتوانا</span><h2 class=\"text-white\">المزيد لتشاهده دائمًا</h2><p class=\"text-silver\"> مع مكتبة Loay IPTV الواسعة والمتنوعة من القنوات والمحتوى، لن تفوتك مبارياتك الرياضية المفضلة أو برامجك ومسلسلاتك المفضلة. </p><p><span class=\"text-white\"> استمتع بقنوات رياضية حصرية ومحتوى ترفيهي متجدد وتجربة مشاهدة مرنة تناسب جميع أفراد العائلة. </span></p><ul class=\"ps-0 list-unstyled content-list\"><li class=\"d-flex align-items-center\"><i class=\"ti ti-circle-check\"></i><span>أكثر من 25,000 قناة عالمية بجودة 4K</span></li><li class=\"d-flex align-items-center\"><i class=\"ti ti-circle-check\"></i><span>أكثر من 500 ألف فيلم جديد وكلاسيكي</span></li></ul>", 5)),
            _createVNode(_component_RouterLink, {
              to: "/about-us",
              class: "btn"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("span", { class: "border-style" }, "عرض قائمة المحتوى", -1)
              ]))]),
              _: 1
            }),
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              src: _imports_2,
              class: "shape shape-7",
              alt: "shape"
            }, null, -1))
          ])
        ])
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("img", {
      src: _imports_3,
      class: "shape shape-6",
      alt: "shape"
    }, null, -1))
  ]))
}